import { render, staticRenderFns } from "./WorksInputFile.vue?vue&type=template&id=a599a55e"
import script from "./WorksInputFile.vue?vue&type=script&lang=ts"
export * from "./WorksInputFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports